import { PMT, ROUND } from '@formulajs/formulajs';
import util from '@core/services/util';

const PERIODS_YEARS = 12;
enum BalloonPeriodStart {
	End = 0,
	BEGINNING = 1,
}

const financials = {
	calculateResidualDollars(amount: any, residualPercent: any) {
		//params
		//amount - this is the MSRP to use to calculate the residual value
		//residualPercent - this is the percentage to use to calculate the residual value - (represented as the full number, in other words, 65% would be 65, not .65)
		let residualDollars = 0;
		//console.log('in calculateResidualDollars', arguments);
		if (!util.anyNull(amount, residualPercent)) {
			const floatAmount = amount;
			const floatPercent = residualPercent;
			residualDollars = floatPercent * 0.01 * floatAmount;
		}
		return residualDollars;
	},

	calculateResidualDollarsOld(amount: any, residualPercent: any) {
		//params
		//amount - this is the MSRP to use to calculate the residual value
		//residualPercent - this is the percentage to use to calculate the residual value - (represented as the full number, in other words, 65% would be 65, not .65)
		let residualDollars = 0;
		//console.log('in calculateResidualDollars', arguments);
		if (!util.anyNull(amount, residualPercent)) {
			const floatAmount = Number.parseFloat(amount);
			const floatPercent = Number.parseFloat(residualPercent);
			if (Number.isNaN(floatAmount) || Number.isNaN(floatPercent)) return residualDollars;
			residualDollars = floatPercent * 0.01 * floatAmount;
		}
		return parseFloat(residualDollars.toFixed(2));
	},

	calculateLeastPaymentAlly(term: number, adjCap: number, residual: number, rate: number) {
		const i = rate / 1200;
		// 1. Calculate PV of Residual
		const pvRes = residual * Math.pow(1 + i, -(term + 1)); //PV__Res = Res x (1 + i) –( N + 1 ) || 19,242.31 = 29,664.25 x (1 + 12.14 )-(42+1)

		// 2. Calculate A (AdjCap - PV_Res)
		const a = adjCap - pvRes; // A = AdjCap – PV__Res ||  23,561.58= 42,803.89 – 19,242.31

		// 3. Calculate Payment
		const payment = a * (i / (1 + i) / (1 - Math.pow(1 + i, -term)));
		return payment;
	},

	convertMFtoAPR(mf: number, lenderCode: string) {
		return mf * 2400;
	},
	convertAPRtoMF(apr: number, lenderCode: string) {
		return apr / 2400;
	},

	ConvertAPRtoMF_ALLY(rate: number) {
		return Number((rate / (1200 * 24)).toFixed(8));
	},
	ConvertMFtoAPR_ALLY(mf: number) {
		return Number((mf * 24 * 1200).toFixed(3));
	},

	calculateLeasePayment(term: any, amount: any, residualPercent: any, moneyFactor: any, msrp: any) {
		//params
		//term - number of months
		//amount - the capitalized cost amount
		//residualPercent - this is the percentage to use to calculate the residual value - (represented as the full number, in other words, 65% would be 65, not .65)
		//moneyFactor - this is the money factor to use - (represented as .00##))
		//msrp - the MSRP to use to calculate the residual
		let payment = 0;
		//console.log('in calculateLeasePayment', arguments);
		if (!util.anyNull(term, amount, residualPercent, moneyFactor, msrp)) {
			//console.log('in calculateLeasePayment', arguments);
			const intTerm = term;
			const floatAmount = amount;
			const floatResidual = residualPercent;
			const floatMsrp = msrp;
			const floatMoneyFactor = moneyFactor;
			const residualDollars = financials.calculateResidualDollars(floatMsrp, floatResidual);
			//console.log('in lease calc', intTerm, floatAmount, floatResidual, floatMsrp, floatMoneyFactor, residualDollars);
			//if (Number.isNaN(intTerm) || Number.isNaN(floatAmount) || Number.isNaN(floatMoneyFactor)) return payment;
			payment = ((floatAmount + residualDollars) * intTerm * floatMoneyFactor + (floatAmount - residualDollars)) / intTerm;
		}
		//console.log(payment, payment.toFixed(2))
		return payment;
		//return parseFloat(payment.toFixed(2));
	},

	calculateLeasePaymentOld(term: any, amount: any, residualPercent: any, moneyFactor: any, msrp: any) {
		//params
		//term - number of months
		//amount - the capitalized cost amount
		//residualPercent - this is the percentage to use to calculate the residual value - (represented as the full number, in other words, 65% would be 65, not .65)
		//moneyFactor - this is the money factor to use - (represented as .00##))
		//msrp - the MSRP to use to calculate the residual
		let payment = 0;
		//console.log('in calculateLeasePayment', arguments);
		if (!util.anyNull(term, amount, residualPercent, moneyFactor, msrp)) {
			//console.log('in calculateLeasePayment', arguments);
			const intTerm = Number.parseInt(term);
			const floatAmount = Number.parseFloat(amount);
			const floatResidual = Number.parseFloat(residualPercent);
			const floatMsrp = Number.parseFloat(msrp);
			const floatMoneyFactor = Number.parseFloat(moneyFactor);
			const residualDollars = Number.parseFloat(financials.calculateResidualDollars(floatMsrp, floatResidual)?.toString());
			//console.log('in lease calc', intTerm, floatAmount, floatResidual, floatMsrp, floatMoneyFactor, residualDollars);
			if (Number.isNaN(intTerm) || Number.isNaN(floatAmount) || Number.isNaN(floatMoneyFactor)) return payment;
			payment = ((floatAmount + residualDollars) * intTerm * floatMoneyFactor + (floatAmount - residualDollars)) / intTerm;
		}
		//console.log(payment, payment.toFixed(2))
		//return payment;
		return parseFloat(payment.toFixed(2));
	},

	calculateLeasePaymentWithApr(capCost: any, apr: any, residualValue: any, term: any, oddDays: any) {
		apr = apr * 0.01; // APR is a percent
		const d = apr / 12;
		const pow = Math.pow(1 + d, 37);
		const p1 = capCost - residualValue / pow;
		const monthlyPayment =
			((capCost - residualValue / Math.pow(1 + apr / 12, term + 1)) * (apr / 12) * (1 + (apr * oddDays) / 365)) / (1 - Math.pow(1 + apr / 12, -term));

		const roundedMonthlyPayment = Math.round(monthlyPayment * 100) / 100;

		return roundedMonthlyPayment;
	},

	//calculateLeasePaymentWithApr(capCost, apr, residualValue, term) {
	//    // Calculate depreciation
	//    const depreciation = (capCost - residualValue) / term;
	//
	//    // Calculate interest
	//    const interest = ((capCost + residualValue) * (apr / 100)) / 12;
	//
	//    // Monthly payment is the sum of depreciation and interest
	//    const monthlyPayment = depreciation + interest;
	//
	//    return monthlyPayment;
	//},
	calculateFinancePayment(term: any, amount: any, rate: any, oddDays: any) {
		return financials.calculateFinancePaymentRaw(term, amount, rate, oddDays).toFixed(2);
	},

	calculateFinancePaymentRaw(term: any, amount: any, rate: any, oddDays: any) {
		//params
		//term - number of months
		//amount - the principal amount
		//rate - the APR to use (represented as the full number, in other words, 6.5% would be 6.5, not .065)
		//oddDays - this is a whole number of odd days (the difference in number of days until the first payment)

		let payment = 0;
		if (!util.anyNull(term, amount, rate, oddDays)) {
			const floatApr = Number.parseFloat(rate) * 0.01;
			const floatPrincipal = Number.parseFloat(amount);
			const intOdd = Number.parseInt(oddDays);
			const intTerm = Number.parseInt(term);

			if (floatApr == 0 && floatPrincipal > 0 && intTerm > 0) {
				payment = floatPrincipal / intTerm;
			} else if (Number.isNaN(intTerm) || Number.isNaN(floatPrincipal) || Number.isNaN(floatApr) || Number.isNaN(intOdd)) {
				payment = 0;
			} else {
				payment = (Number(floatPrincipal) * (floatApr / 12) * (1 + (floatApr * intOdd) / 360)) / (1 - Math.pow(1 + floatApr / 12, -intTerm));
			}
		}
		return payment;
	},

	/**
	 * @param {number} term Number of months
	 * @param {number} amount The principal amount
	 * @param {number} rate The APR to use (represented as the full number, in other words, 6.5% would be 6.5, not .065)
	 * @param {*} oddDays This is a whole number of odd days (the difference in number of days until the first payment)
	 * @param {number} balloonAmount
	 * @return {*} The monthly finance amount
	 */
	calculateBalloonPayment(term: number, amount: number, rate: number, oddDays: any, balloonAmount: number) {
		let payment: number | Error = 0.0;

		const rateAsPercentage = rate * 0.01;
		const termWithoutFinalPayment = term - 1;
		const presentValueResidual = balloonAmount * (1 + rateAsPercentage / PERIODS_YEARS) ** -term;

		payment = Number(ROUND(PMT(rateAsPercentage / PERIODS_YEARS, termWithoutFinalPayment, amount - presentValueResidual, null, BalloonPeriodStart.End), 2));
		if (typeof payment == 'number') payment = payment * -1;

		// console.log("balloon amounts", balloonAmount, amount, rateAsPercentage, -term, presentValueResidual)
		// console.log("final payment", payment, interestPaid, amount - balloonAmount, termWithoutFinalPayment)

		return payment;
	},

	calculateDocStamps(amount: any, state: string) {
		switch (state) {
			case 'FL':
				//PROVIDED BY AVIDAN 12/9/2020 - this is how CDK calculates it
				return Number((financials.roundUpToNearestHundreds(amount) * 0.0035).toFixed(2));
			//return Number((financials.roundUpToNearestHundreds(amount) / 0.9965 - financials.roundUpToNearestHundreds(amount)).toFixed(2));
			default:
				return 0.0;
		}
	},

	calculateCDKDocStamps(amount: any, state: string) {
		let preDocsStamps = 0.0;
		let newTotal = 0.0;
		let postDocStamps = 0.0;
		switch (state) {
			case 'FL':
				//PROVIDED BY AVIDAN 12/9/2020 - this is how CDK calculates it
				preDocsStamps = Number((financials.roundUpToNearestHundreds(amount) * 0.0035).toFixed(2));
				newTotal = amount + preDocsStamps;
				postDocStamps = Number((financials.roundUpToNearestHundreds(newTotal) * 0.0035).toFixed(2));
				return postDocStamps;
			default:
				return 0.0;
		}
	},

	round(num: number, decimalPoints = 2) {
		const multiplier = Math.pow(10, decimalPoints);
		return Math.round((num + Number.EPSILON) * multiplier) / multiplier;
	},

	roundUpToNearestHundreds(amount: number) {
		return Math.ceil(amount / 100.0) * 100.0;
	},

	calculateStateSalesTax(baseAmount: number, rate: number, state?: string) {
		//params
		//baseAmount - the amount to base the tax on
		//rate - the tax percentage to use (represented as the full number, in other words, 6.5% would be 6.5, not .065)
		//state - the state to use (some states will have different calculations for taxes)
		let tax: any = 0.0;
		if (baseAmount > 0 && rate > 0 && state != null && state != '') {
			switch (state) {
				default:
					tax = financials.roundFloatNumberWithoutTrailingZeroes(baseAmount * (rate / 100), 2);
					break;
			}
		}
		return tax;
	},

	calculateCountySalesTax(baseAmount: number, rate: number, state: string) {
		//params
		//baseAmount - the amount to base the tax on
		//rate - the tax percentage to use (represented as the full number, in other words, 6.5% would be 6.5, not .065)
		//state - the state to use (some states will have different calculations for taxes)
		let tax: any = 0.0;
		if (baseAmount > 0 && rate > 0 && state != null && state != '') {
			switch (state) {
				case 'FL':
					tax = financials.roundFloatNumberWithoutTrailingZeroes(Math.min(5000, baseAmount) * (rate / 100), 2);
					break;
				default:
					tax = financials.roundFloatNumberWithoutTrailingZeroes(baseAmount * (rate / 100), 2);
					break;
			}
		}
		return tax;
	},

	roundFloatNumberWithoutTrailingZeroes(num: any, dp: any) {
		//params
		//num - the number to round
		//dp - the number of characters to use (typically 2 for a currency)
		//console.log('in roundFloatNumberWithoutTrailingZeroes',num,dp);
		const numToFixedDp = Number(num).toFixed(dp);
		return numToFixedDp;
	},

	/**
	 * Calculate APR given loan parameters using bisection method.
	 *
	 * @param {number} loanAmount - Principal amount of the loan.
	 * @param {number} monthlyPayment - Fixed monthly payment.
	 * @param {number} numberOfPayments - Total number of monthly payments.
	 * @param {number} tolerance - Acceptable error tolerance (default 1e-7).
	 * @param {number} maxIterations - Max iterations for convergence (default 100).
	 * @returns {number} APR as a percentage (e.g., 3.99 for 3.99%)
	 */
	calculateAPR(principalAmount: number, financeCharge: number, numberOfPayments: number, oddDays: number, tolerance = 1e-10, maxIterations = 200) {
		function financeChargeForRate(rate: number) {
			if (rate === 0) return 0;

			const monthlyPayment = (rate * principalAmount) / (1 - Math.pow(1 + rate, -numberOfPayments));

			// Adjusted: add interest accrued during odd days before first payment
			const oddDayInterest = principalAmount * rate * (oddDays / 30);
			return monthlyPayment * numberOfPayments - principalAmount + oddDayInterest;
		}

		let low = 0;
		let high = 0.1; // 10% monthly interest upper bound
		let mid = 0;
		let iteration = 0;

		while (iteration < maxIterations) {
			mid = (low + high) / 2;
			const calcFinanceCharge = financeChargeForRate(mid);

			if (Math.abs(calcFinanceCharge - financeCharge) < tolerance) {
				break;
			}

			if (calcFinanceCharge > financeCharge) {
				high = mid;
			} else {
				low = mid;
			}

			iteration++;
		}

		const monthlyRate = mid;
		const annualAPR = monthlyRate * 12 * 100;

		return annualAPR;
	},
};

export default financials;
